import { IStackedBarPoints } from '../../../chart/interfaces/barGraph';
import { StatsRunStageInfo } from '../ActivationSyncHistory/models/stats-run-stage';
import { ActivationStatsDataPoint } from '../ActivationSyncHistory/models/stats-data';
import dayjs from 'dayjs';

export function convertActivationStatsDataPointsToStackedData(
  dataPoints: ActivationStatsDataPoint[],
  stageInfo: StatsRunStageInfo
): IStackedBarPoints {
  return dataPoints.map(dataPoint => ({
    name: dayjs(dataPoint.startTime).unix(),
    value: dataPoint.total + dataPoint.failed,
    stackedData: [dataPoint.failed, dataPoint.total],
    extra: {
      tooltipData: {
        dataPoint: dataPoint,
        stageInfo: stageInfo
      }
    }
  }));
}
